import { Row, Col } from "../../App.styles";

const Video = ({ useQuery }) => {
  const { task_subtype, video_length } = useQuery();

  const getSubtype = (subtype) => {
    switch (subtype) {
      case 0:
      default:
        return "standard video";
      case 1:
        return "animated gif";
      case 2:
        return "audio only";
    }
  };

  return (
    <>
      <Row>
        <Col>
          <p>Complete by: Video</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Video length: {video_length ? `${video_length}s` : "unlimited"}</p>
        </Col>
      </Row>
      <Row>
        <Col>
          <p>Share as: {getSubtype(parseInt(task_subtype))}</p>
        </Col>
      </Row>
    </>
  );
};

export default Video;
